import { userConstants } from '../../_constants';

const initialState = { forgotPasswordLoading: true, data: '', error: false };

export function forgotPasswordReducer(state = initialState, action) {
    
    switch (action.type) {
        case userConstants.REQUEST_FORGOT_PASSWORD:
            return {
                forgotPasswordLoading: true,
                data: '',
                error: false
            };
        case userConstants.RECEIVE_FORGOT_PASSWORD:
            return {
                forgotPasswordLoading: false,
                data: action.forgotPassword,
                error: false
            };
        case userConstants.FORGOT_PASSWORD_ERROR:
            return {
                forgotPasswordLoading: false,
                data: '',
                error: true
            };
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/User/forgotPassword.reducer.js